const JourneyElementTypes = {
  AUDIENCE: 'audience',
  BOT: 'bot',
  CHAT: 'chat',
  CONDITION: 'media_condition',
  DISPLAY: 'display_campaign',
  DMP: 'dmp',
  ECOM: 'e_com',
  EMAIL: 'email_campaign',
  MOBILE_APP: 'mobile_application',
  PUSH: 'push',
  USER_ACTION: 'user-action',
  SOCIAL: 'social_campaign',
  SEARCH: 'search_campaign',
  SMS: 'sms',
  STORE: 'store',
  TRIGGER: 'trigger',
  TIMER: 'timer',
  VIDEO: 'video_campaign',
  WEBSITE: 'web_site',
  OUT_OF_HOME: 'out_of_home',
  ADDRESSABLE_TV: 'addressable_tv',
  MEDIA: 'media',
  NATIVE: 'native',
};

export default JourneyElementTypes;
